import { z } from 'zod'

/** What a requester may learn. Never carries item data (request-access spec §6.1). A declined request reads as `requested`. */
export const accessRequestStates = ['none', 'requested', 'has-access'] as const
export const accessRequestStateSchema = z.object({ state: z.enum(accessRequestStates) })
export type AccessRequestState = z.infer<typeof accessRequestStateSchema>

/** View (READ) or Edit (WRITE). DELETE is never granted through a request. */
export const approvablePermissions = ['READ', 'WRITE'] as const
export type ApprovablePermission = (typeof approvablePermissions)[number]
export const approveAccessRequestBodySchema = z.object({ permission: z.enum(approvablePermissions) })

/** A pending request as an approver sees it (Share dialog, Home). */
export const accessRequestViewSchema = z.object({
  entity: z.object({
    id: z.string(),
    name: z.string().optional(),
    type: z.string(),
  }),
  requester: z.object({
    userId: z.string(),
    email: z.string().describe('Shown to approvers: by asking, the requester asks to be identified (spec §6.4)'),
    name: z.string().optional(),
    picture: z.string().nullable().optional(),
  }),
  createdAt: z.string(),
})
export type AccessRequestView = z.infer<typeof accessRequestViewSchema>
